<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="상품문의 조회"
      desc="전체 상품문의 게시물들의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1500"
                 nextPageName="nopage"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="estimate_content" slot-scope="props" style="width: 120px; margin: auto;">
        <div @click.stop.prevent="clickEst(props.item)">
          <i class="material-icons">library_books</i>
        </div>
      </div>

      <div slot="product" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <span @click="newTab(props.item.product_id)">{{ props.item.product }}</span>
      </div>

      <div slot="title" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <span @click="$router.push(getPath(`product/inquiry/create?id=${props.item.id}`))">{{ props.item.title }}</span>
      </div>

      <div slot="first_img" slot-scope="props">
        <div style="display: inline-block; text-align: center"
             :style="thumbImgField(props.item.img)" v-if="props.item.img"></div>
      </div>

      <div slot="confirm_status" slot-scope="props" style="width: 120px; margin: auto;">
        <button v-if="props.item.is_checked"
              class="button state-btn">문의확인</button>
        <button v-if="!props.item.is_checked"
              class="button state-btn ests-btn-confirm-new"
              @click.stop.prevent="clickConfirm(props.item,'confirm-new')">신규문의확인</button>
      </div>

      <div slot="comment_status" slot-scope="props" style="width: 120px; margin: auto;">
        <span v-if="props.item.answerer">답변 확인</span>
        <span v-else>답변 미확인</span>
      </div>

      <div slot="comment_reg" slot-scope="props" style="width: 120px; margin: auto;">
        <button v-if="props.item.comment_author"
                class="button is-grey cancel"
                @click.stop.prevent="clickAnswer(props.item.id)">답변 수정</button>
        <button v-if="!props.item.comment_author"
                class="button state-btn review-make-comment"
                @click="clickAnswer(props.item.id)">답변 달기</button>
      </div>

    </admin-table>
  </div>
</template>

<script>
  import moment from 'moment'
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'ProductInquiryAll',
    mixins: [
      ListMixin
    ],

    created() {
      this.initializing('product_inquiry_all', 'product/inquiry');

      if (this.isLaunchpack) {
        let filterData = [];
        this.filterData.forEach(item => {
          if (['카테고리'].indexOf(item.title) === -1) {
            filterData.push(item);
          }
        })
        filterData.push({
          title: '서비스 구분',
          type: 'dropdown',
          key: 'channel',
        })
        this.filterData = filterData;
      }

      //this.nowTime = moment().format("YY-MM-DD");
      //this.getData();
      //this.getCategory();
    },

    data() {
      return {
        tableItems: [],
        qnaItem:{
          id:0,
          answer_content:''
        },
        nowTime: "",
        nowOpened: "",
        // 카테고리
        catArr1: [],
        cat2: [], //1차 카테고리 관련된 카테고리만
        cat3: [], //2차 카테고리 관련된 카테고리만
        catArr2: [],
        catArr3: [],
        // 지역 데이터 Array
        sido: [],
        sigungu: [],
        dong: [],
        filtered: {
          min_price:"",
          max_price:"",
          start: "",
          end: "",
          cat1: "",
          cat2: "",
          cat3: "",
          sido: "",
          sigungu: "",
          ordering: "",
          is_checked:"false",
          is_answered:"true",
          dong: "",
          search_type: 'all',
          search_keyword: '',
          page_num: 1,
          page_length: 10
        },
        filteredCount: 0,
        allCount: 0,
        pageCount: 0,
        // 페이지 개수 보기
        pageLengthList: [
          {
            label: "10개씩 보기",
            value: 10
          },
          {
            label: "25개씩 보기",
            value: 25
          },
          {
            label: "50개씩 보기",
            value: 50
          },
          {
            label: "100개씩 보기",
            value: 100
          }
        ],
        // 게시물 확인상태
        confirmStatus: [
          { label: "전체", value: "" },
          { label: "확인", value: "true" },
          { label: "미확인", value: "false" }
        ],
        // 답변여부
        replyStatus: [
          { label: "전체", value: "" },
          { label: "완료", value: "false" },
          { label: "대기", value: "true" }
        ],
        searchType: [
          { label: "전체", value: "all" },
          { label: "제목", value: "title" },
          { label: "상품명", value: "product" },
          { label: "질문내용", value: "question_content" },
          { label: "답변내용", value: "answer_content" },
          { label: "작성자id", value: "writer_id" },
          { label: "작성자이름", value: "writer_name" }
        ]
      };
    },
    watch: {
      'filtered.ordering'(){
        this.getData();
      },
      'filtered.is_answered'(){
        this.getData();
      },
      'filtered.is_checked'(){
        this.getData();
      }
    },
    methods: {
      getDataFromServer() {
        this.getData();
      },
      newTab(id){
        window.open(this.getPath(`product/create?id=${id}`));
      },
      /*saveQna(){
        if(!this.qnaItem.answer_content){
          this.toast('답변을 입력해주세요.');
          return;
        }
        this.$axios.patch(this.getUrl('product/inquiry/'+this.qnaItem.id),{
          answer_content: this.qnaItem.answer_content
        }).then(res=>{
          if(res.status===200){
            this.getData();
            this.$refs.qnaModal.close();
          }
        })
      },*/
      // 답변 달기
      clickAnswer(id){
        this.$router.push(this.getPath('product/inquiry/create?id='+id));
        /*this.qnaItem = undefined;
        this.qnaItem = {
          id: id,
          answer_content:''
        };
        this.$axios.get(this.getUrl('product/inquiry/'+id)).then(res=>{
          if(res.status===200){
            this.qnaItem = res.data;

            let value = {
              qnaItem: this.qnaItem,
              url: 'product/inquiry/'+this.qnaItem.id,
              paramName: 'answer_content'
            };
            this.$store.commit('openModal', {type:'modal-inquiry-answer',value:value})
          }
        })*/
      },
      clickConfirm(item) {
        // 서버에 확인 상태 전송
        this.$axios.post(this.getUrl('product/inquiry/'+ item.id))
        .then(res => {
          if(res.status===200){
            this.getData();
          }
        });
      },

      prevPage() {
        if(this.filtered.page_num > 1) {
          this.filtered.page_num -= 1;
          this.getData();
        }
      },
      nextPage() {
        if(this.filtered.page_num < this.pageCount) {
          this.filtered.page_num += 1;
          this.getData();
        }
      },
      changePage(num) {
        this.filtered.page_num = num;
        this.getData();
      },
      selPageLen(length) {
        this.filtered.page_length = length;
        this.filtered.cur_page = 1;
        this.getData();
      },
      selSearchType(type) {
        this.filtered.search_type = type;
      },
      clickSearch() {
        this.filtered.cur_page = 1;
        this.getData();
      },
      selDateMin(date) {
        this.filtered.start = date;
        this.getData();
      },
      selDateMax(date) {
        this.filtered.end = date;
        this.getData();
      },
      selectCat1(res) {
        this.filtered.cat1 = res.value;
        this.cat2 = this.get_cat2();
        this.getData();
      },
      selectCat2(res) {
        this.filtered.cat2 = res.value;
        this.cat3 = this.get_cat3();
        this.getData();
      },
      selectCat3(res) {
        this.filtered.cat3 = res.value;
        this.getData();
      },
      getCategory(){ // 카테고리 가져오기
        this.$axios.get('admin/category')
          .then(res => {

            this.catArr1 = [];
            this.catArr2 = [];
            this.catArr3 = [];

            for (let i = 0; i < res.data.length; i++) {
              let cat = res.data[i];
              // 1차 카테고리 추가
              this.catArr1.push({value: cat.id, label: cat.name});

              for (let j = 0; j < cat.child.length; j++) {
                let cat2 = cat.child[j];
                // 2차 카테고리 추가
                this.catArr2.push({parent: cat.id, value: cat2.id, label: cat2.name});

                for (let k = 0; k < cat2.child.length; k++) {
                  let cat3 = cat2.child[k];
                  // 3차 카테고리 추가
                  this.catArr3.push({parent: cat2.id, value: cat3.id, label: cat3.name});
                }
              }
            }
          });
      },
      get_cat2() {
        let cat = [];
        for (let i = 0; i < this.catArr2.length; i++) {
          if (this.catArr2[i].parent === this.filtered.cat1) {
            cat.push(this.catArr2[i]);
          }
        }

        return cat;
      },
      get_cat3() {
        let cat = [];
        for (let i = 0; i < this.catArr3.length; i++) {
          if (this.catArr3[i].parent === this.filtered.cat2) {
            cat.push(this.catArr3[i]);
          }
        }

        return cat;
      },
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  ////@import '~assets/css/reset';
  @import '~assets/css/lp_main';

  .tr-whole-border th
    padding 12px 6px

  .many-field-tr td
    padding 6px

  .progress-btn
    border-radius 3px
    display inline-block
    width 84px
    padding 6px 0
    margin 2px
    font-weight bold
    font-size .8rem

  .bid-state
    margin 2px 0
    color #fff
    border-radius 3px
    display inline-block
    width 76px
    padding 4px

  .btn-request-sheet
    color white
    background-color #5cb85c

  .bid-state-done
    background-color #5cb85c
  .bid-state-ing
    background-color #1c7cd5
  .bid-state-ok
    background-color #5cb85c
  .bid-state-no
    background-color #f0ad4e

  .q-title
    font-size 0.9rem
    color $primary
    margin-top 20px
    margin-bottom 4px

  .est-title
    padding 20px
    font-size 1.2rem
    border-bottom 1px solid $primary

  .est-table
    padding 20px
    max-height 80vh

  .est-table table
    width 100%

  .est-table table
  .est-table th
  .est-table td
    border 0
    padding 4px 0
    text-align center

  .modal-title
    margin 20px 0 8px 0
    color #064160
    font-size 0.9rem
    font-weight bold

  .modal-desc
    padding 20px
    background-color #eee

  .td-est:hover
    background-color #eeeeee
    cursor pointer

  .lp-btn-bid
    cursor pointer
    border-radius 3px
    color white
    padding 4px 6px
    font-size 0.8rem
    width 74px
    margin auto
    margin-top 4px
    background-color $primary

  .btn-add
    width 24px
    height 24px
    line-height 23px
    text-align center
    font-size 1rem
    color white
    background-color $primary
    border-radius 50%

  .lp-custom-modal-btns
    padding 20px

  .btn-close
    width 45px
    color #777
    text-align center
    margin auto 0

</style>
